import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { merge } from 'rxjs';
import { INPUT, RADIOGROUP } from 'src/app/_models/data/constants';
import { Question } from 'src/app/_models/question';
import { QuizEnvelop } from 'src/app/_models/quizEnvelop';
import { Student } from 'src/app/_models/student';
import { AuthService } from 'src/app/_services/auth.service';
import { Prompt } from './../../_models/prompt';
import { Subscription } from './../../_models/subscription';
import { ImageService } from './../../_services/image.service';
import { QuizService } from './../../_services/quiz.service';


@Component({
  selector: 'app-do-prompt',
  templateUrl: './do-prompt.component.html',
  styleUrls: ['./do-prompt.component.css']
})
export class DoPromptComponent implements OnInit {
  @Input() quizEnvelop = new QuizEnvelop()
  @Input() student = new Student()
  @Input() subscription = new Subscription()
  @Input() subscriptionId = 0
  @Input() prompt:Prompt = undefined

  hasEnrollments = false
  isPremium: false
  studentUserId: 0
  questionIndex = 0
  loading=false
  loading_option_images=false
  isLastQuestion=false
  question = new Question()
  doQuestionForm:FormGroup
  choiceValues=[]
  isRadioGroup=false
  isInput =false
  constructor(
    public authService: AuthService,
    private quizService:QuizService,
    private imageService:ImageService
  ) {

  }

  ngOnInit(): void {
    this.isRadioGroup= this.prompt.questionPresentation==RADIOGROUP
    this.isInput= this.prompt.questionPresentation==INPUT
    this.extractChoicesDisplay()
    this.loading=true
    this.initForm()
    this.onChanges()



  }

  initForm(){

    if(this.isInput){
      this.doQuestionForm= new FormGroup({
        'answerInput': new FormControl(this.prompt.answerGiven.display)
      })
    }else if(this.isRadioGroup){
      this.doQuestionForm= new FormGroup({
        'answerChoice': new FormControl(this.prompt.answerGiven.value)
      })
    }

    this.loading=false
  }
  extractChoiceValue(choice){
    return choice.value
  }

  extractChoicesDisplay(){
    this.loading_option_images=true
    let oList = []

    for(let i=0;i < this.prompt.choiceOptions.length;i++){
      let myChoice=this.prompt.choiceOptions[i]
      if(myChoice['is_media_present']){
        let   partName = myChoice['name']
        oList.push(this.imageService.questionOptionImage(this.prompt.server_prompt_id,partName))
      }
      if(oList.length==0){
        this.loading_option_images=false
      }
    }

  merge(oList).subscribe(
        resultArray=>{
         for(let i=0;i < this.prompt.choiceOptions.length;i++){
           let iValue = resultArray[i]
           let myChoice=this.prompt.choiceOptions[i]
           myChoice['display']="<img src=data:image/png;base64,"+iValue+">"
         }
         this.loading_option_images=false
        }
      )


  }
  onChanges(): void {

      if(this.isInput){
        this.doQuestionForm.get('answerInput').valueChanges.subscribe(val => {
          this.quizService.markPrompt(this.quizEnvelop.server_quiz_envelop_id,this.prompt.server_prompt_id,val).subscribe(
            x=>{this.question=x}
          )
        });
      }else if(this.isRadioGroup){
        this.doQuestionForm.get('answerChoice').valueChanges.subscribe(val => {

          this.quizService.markPrompt(this.quizEnvelop.server_quiz_envelop_id,this.prompt.server_prompt_id,JSON.stringify(val)).subscribe(
            x=>{this.question=x}
          )
        });
      }
    }



}
